import script from "./ItalicIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ItalicIcon.vue?vue&type=script&setup=true&lang=js"

export default script